<template>
  <div class="flex flex-col h-full overflow-hidden">
    <div class="flex items-center justify-between m-1">
      <SelectAllMate
        v-if="!isRankingEnabled"
        :active-mate-id="activeMateId"
        v-model:show="showOcSelector"
        @confirm="onConfirmOc"
      />
      <TimeSort :sort="activeSort" @update:sort="onSorterChange" />
    </div>
    <ThreadList
      class="flex-1"
      ref="threadList"
      :on-pull-load="() => reload()"
      :on-scroll-load="() => loadNextPage()"
    >
      <div class="flex flex-col gap-4 px-4 py-2 flex-1">
        <!-- 奖励卡片 -->
        <MissionRewardCard
          v-if="dispatchMission?.dispatchMemberzz"
          :dispatch-mission="dispatchMission"
        />

        <!-- 日志卡片列表 -->
        <div class="flex flex-col gap-3">
          <template
            v-for="(journal, index) in dispatchMission?.obtainedJournalzz"
            :key="index"
          >
            <MissionLogItem
              :journal="journal"
              :is-select="isSelect"
              :is-ranking-enabled="isRankingEnabled"
              :include="include"
              @select="emit('select', journal)"
            />
          </template>
        </div>
      </div>
    </ThreadList>
  </div>
</template>

<script setup lang="ts">
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { useMission } from "@/stores/mission";
import { Mate, MateDispatch, MateJournal } from "@/types/entity";
import { onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import TimeSort from "../common/TimeSort.vue";
import { useMate } from "@/stores/mate";

const route = useRoute();
const missionStore = useMission();
const dispatchMission = ref<Partial<MateDispatch>>();

const props = defineProps<{
  isSelect?: boolean;
  mateId?: number;
  include?: number[];
}>();

const emit = defineEmits<{
  (e: "select", journal: MateJournal): void;
}>();

const threadList = ref<ThreadListInstance>();
const isRankingEnabled = ref<boolean>(false);

const reload = async () => {
  missionStore.mateJournalList = [];
  dispatchMission.value = {
    obtainedJournalzz: [],
  };
  threadList.value?.resetScrollLoadingState();
};

const loadNextPage = async () => {
  const { length } = missionStore.mateJournalList;
  const page = length / 5 + 1;
  if (length !== 0 && length % 5 !== 0) return false;
  const list = await missionStore.getMateJournalList(
    page,
    activeMateId.value,
    activeSort.value,
    activeCoinRankId.value
  );
  dispatchMission.value = {
    obtainedJournalzz: missionStore.mateJournalList,
  };
  return list.length === 5;
};

const activeSort = ref<"desc" | "asc">("desc");

const onSorterChange = (sort: "desc" | "asc") => {
  activeSort.value = sort;
  reload();
};

const showOcSelector = ref(false);
const activeMateId = ref<number | undefined>(props.mateId);
const activeCoinRankId = ref<number | undefined>(undefined);
const onConfirmOc = (value?: number) => {
  activeMateId.value = value;
  reload();
  showOcSelector.value = false;
};

const otherMate = ref<Mate | undefined>(undefined);

const mateStore = useMate();
onBeforeMount(async () => {
  const mateUuid = route.query.mateUuid as string;
  const mateId = route.query.mateId as string;
  const coinRankId = Number(route.query.coinRankId);
  // 获取路由参数

  if (mateId) {
    activeMateId.value = Number(mateId);
  }
  if (coinRankId) {
    activeCoinRankId.value = coinRankId;
  }
  if (mateUuid) {
    isRankingEnabled.value = true;
    missionStore.mateJournalList.length = 0;
    otherMate.value = await mateStore.getOrFetchMate(mateUuid);
  }

  reload();
});
</script>
